module.exports = __webpack_public_path__ + "img/dreamtech.74d78517.png";